// extracted by mini-css-extract-plugin
export var animation = "FormError-module--animation--0f011";
export var attach = "FormError-module--attach--bcb9b";
export var error = "FormError-module--error--537f6";
export var fadeInAnimation = "FormError-module--fadeInAnimation--753eb";
export var scrollLeft = "FormError-module--scroll-left--e93ff";
export var shake = "FormError-module--shake--4c986";
export var title = "FormError-module--title--d5433";